<div style="margin-top: 15px;display: flex;justify-content: center;">
    <mat-slide-toggle labelPosition="before" [ngModel]="measurementFeatureActive"
        (ngModelChange)="setMeasurementFeatureActiveState()">
        <span style="font-weight: bold;">{{measurementFeatureActive ? 'Deactivate feature' : 'Activate feature'}}</span>
    </mat-slide-toggle>
</div>
<div class="container">
    <mat-checkbox [ngModel]="enableMeasurementFunction" (ngModelChange)="setMeasurementFunctionState()"
        [disabled]="!measurementFeatureActive ||enableFreeDrawingFunction">
        Enable measurement
    </mat-checkbox>
    <mat-checkbox [ngModel]="enableSnappingFunction" (ngModelChange)="setSnappingFunctionState()"
        [disabled]="!measurementFeatureActive ||enableFreeDrawingFunction">
        Enable snapping
    </mat-checkbox>
    <mat-checkbox [ngModel]="enableFreeDrawingFunction" (ngModelChange)="setFreeDrawingFunctionState()"
        [disabled]="!measurementFeatureActive ||enableMeasurementFunction">
        Enable free measuring
    </mat-checkbox>
    <button matTooltip="Delete all measurements" class="fullwidth color"
        [disabled]="!measurementFeatureActive || getDeleteDisabledState()" mat-button (click)="deleteMeasurements()">
        Delete all measurements
        <mat-icon iconPositionEnd>delete</mat-icon>
    </button>
</div>